import http from '../_http'

const policy = {
  //default
  summaryPolicy: (m) => { return http.get(`manager/webcastle/policy`, m); },
  listPolicy: (m) => { return http.post(`manager/webcastle/policy/list`, m); },
  detailPolicy: (m) => { return http.get(`manager/webcastle/policy/${m.id}`); },

  //crud
  insertPolicy: (m) => { return http.post(`manager/webcastle/policy`, m); },
  updatePolicy: (m) => { return http.put(`manager/webcastle/policy`, m); },
  deletePolicy: (m) => { return http.delete(`manager/webcastle/policy/${m.id}`); },

  //latest
  latestPolicy: (m) => { return http.get(`manager/webcastle/policy/latest`, m); },
}

export default policy

export { policy }